import appinstance from "./appinstance";

const applicationService = {

    verifyAutoLoginToken: async (payload) => {
        const response = await appinstance.post(`/verify-auto-login`, payload);
        return response;
    },
};

export default applicationService;